<mat-card class="mat-elevation-z4">
  <mat-card-title>
    <div>
      <div>
        <h4 style="font-weight: bold;">{{apiNavLink.label}}
          <div *ngIf="!allAPIsArePublic && apiNavLink.public" style=" margin-left: 8px; display: inline;" matBadge="P" matBadgeColor="primary" matTooltip="API is public" matTooltipPosition="right">
            &nbsp;
          </div>
        </h4>
      </div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <p>{{apiNavLink.short_description || '&nbsp;'}}</p>
  </mat-card-content>
  <mat-card-footer>
    <a [routerLink]="['/dash','oapi-render', apiNavLink.name]">API spec</a>
    <a [routerLink]="['/dash','oapi-render', apiNavLink.name]">Doc</a>
  </mat-card-footer>
</mat-card>
